import { COLOR_PALETTE } from 'constants/ui';

// Purple "Needed" accent. The deep PURPLE[7] is tuned for a LIGHT backdrop; on a
// DARK backdrop (dark theme's field body / paper) it washed out to ~2.7:1 text
// contrast (DEV-4501), so it lifts to a lighter purple in dark mode — mirroring
// the roll-up NavNeededIndicator (DEV-4496) so the two signals read identically.
const getNeededPurple = palette =>
  palette.mode === 'dark' ? COLOR_PALETTE.PURPLE[4] : COLOR_PALETTE.PURPLE[7];

// The "!" glyph sits INSIDE the purple pill, so it must contrast the pill fill,
// not the page. On the light-mode deep-purple pill it stays white; on the
// dark-mode light-purple pill it flips to a deep purple (else white-on-lavender
// would drop to ~1.9:1).
const getNeededGlyphColor = palette =>
  palette.mode === 'dark' ? COLOR_PALETTE.PURPLE[10] : '#ffffff';

export const indicatorStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  position: 'absolute',
  top: '-10px',
  right: '8px',
  zIndex: 1,
  backgroundColor: ({ palette }) => palette.background.paper,
  padding: '0 4px',
  borderRadius: '4px',
};

export const neededBadgeStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  color: ({ palette }) => getNeededPurple(palette),
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '18px',
  cursor: 'default',
};

export const neededIconStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '14px',
  height: '14px',
  borderRadius: '50%',
  backgroundColor: ({ palette }) => getNeededPurple(palette),
  color: ({ palette }) => getNeededGlyphColor(palette),
  fontSize: '10px',
  fontWeight: 700,
  lineHeight: 1,
  flexShrink: 0,
};

// "Not needed" is an ACTION, not part of the "Needed" status — so it reads as a
// distinct, self-contained ghost button (own border + rounded pill) with real
// separation from the badge, instead of a text sibling divided by a hairline that
// let the two bleed into one "Needed | Not needed" phrase (DEV-4603).
export const suppressButtonStyles = {
  minWidth: 'auto',
  height: '18px',
  minHeight: '18px',
  padding: '0 8px',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  color: ({ palette }) => palette.text.secondary,
  border: '1px solid',
  borderColor: ({ palette }) => palette.divider,
  borderRadius: '10px',
  backgroundColor: 'transparent',
  '&:hover': {
    color: ({ palette }) => getNeededPurple(palette),
    borderColor: ({ palette }) => getNeededPurple(palette),
    backgroundColor: 'transparent',
  },
};

export const overriddenContainerStyles = {
  display: 'inline-flex',
};
